<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{ $t("quartz.scheduleJob.list") }}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <!-- <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/master"><span>{{$t('tlt.master')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/master/location"><span>{{$t('tlt.location')}}</span></router-link></li> -->
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-primary" v-on:click="MMFNew('quartzSchedule')">
                        <i class="fa fa-fw fa-lg fa-plus"></i>
                        <span class="text">{{ $t("btn.basic.add") }}</span>
                    </button>
                </div>
            </div>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div
                        id="collapseOne"
                        class="collapse show "
                        aria-labelledby="headingOne"
                        data-parent="#accordionFilter"
                        >
                        <div class="card-body">
                            <form class="row">
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("quartz.scheduleJob.jobName") }}:
                                    </label>
                                    <input class="form-control" type="text" v-model="jobName"/>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("quartz.scheduleJob.module") }}:
                                    </label>
                                    <select class="form-control"  v-model="module">
                                        <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                        <option v-for="(item,index) in moduleList" :value="item" :key=index>{{item}}</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("quartz.scheduleJob.methodReference") }}:
                                    </label>
                                    <input class="form-control" type="text" v-model="methodReference"/>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("quartz.scheduleJob.status") }}:
                                    </label>
                                    <select class="form-control"  v-model="status">
                                        <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                        <option value=1 >{{ $t("btn.basic.send") }}</option>
                                        <option value=0 >{{ $t("btn.basic.quartzStop") }}</option>
                                    </select>
                                </div>
                                <div class="col-lg-4 align-self-end">
                                    <div class="float-lg-right">
                                        <button class="btn btn-outline-secondary mr-1" type="button" 
                                         v-on:click="MMFClearFilter('quartzSchedule')">
                                            <i class="fa fa-fw fa-lg fa-eraser"></i>
                                            <span class="text">{{ $t("btn.basic.clear") }}</span>
                                        </button>
                                        <button class="btn btn-primary" type="button" v-on:click="MMFLoadRows('quartzSchedule')">
                                            <i class="fa fa-fw fa-lg fa-search"></i>
                                            <span class="text">{{ $t("btn.basic.search") }}</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div id="quartzScheduleTable" class="content">
                <div class="card my-1">
                    <div
                        id="collapseTwo"
                        class="collapse show"
                        aria-labelledby="headingTwo"
                        data-parent="#accordionResult"
                        >
                        <div class="card-body">
                            <mmf-table  entity="quartzSchedule"
                                        inline-actions-disabled singleChoice>
                                <div slot="btnList" class="btn-group">
                                    <button class="btn btn-outline-primary" v-on:click="runJob()" :disabled="isDisable">
                                        <i class="fa fa-play-circle" aria-hidden="true"></i>
                                        <span class="text">{{ $t("btn.basic.run") }}</span>
                                    </button>
                                    <button v-bind:class="'btn btn-outline-primary'" v-on:click="pauseJob()" :disabled="!isPauseAble()">
                                        <i class="fa fa-stop-circle" aria-hidden="true"></i>
                                        <span class="text">{{ $t("btn.basic.quartzStop") }}</span>
                                    </button>
                                    <button v-bind:class="'btn btn-outline-primary'" v-on:click="resumeJob()" :disabled="!isResumeAble()">
                                        <i class="fa fa-reply" aria-hidden="true"></i>
                                        <span class="text">{{ $t("btn.basic.resume") }}</span>
                                    </button>
                                </div>
                            </mmf-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';
import { filterFields}  from "@/model/quartz/QuartzSchedule";
import MmfTable from "@/components/MmfTable";
const { mapFields } = createHelpers({
    getterType: 'quartzSchedule/getField',
    mutationType: 'quartzSchedule/updateField',
});

export default {
  name: "quartzScheduleList",
  data () {
    return {
      
    }
  },
  components: { MmfTable },
  computed: {
    ...mapFields(filterFields),
    ...mapState({
        moduleList: state => state.quartzSchedule.moduleList,
        rows: state => state.quartzSchedule.rows,
        checkedItems: state => state.quartzSchedule.checkedItems,
        checkedEntity: state => state.quartzSchedule.entity,
        isDisable() {
            return this.checkedItems.length <= 0;
        }
    })
  },
  methods: {
    ...mapActions("quartzSchedule", ["getAllModuleList"]),
    ...mapActions("base", ["MMFselectRow", "MMFselectAllRows", "MMFNew", 
    "MMFEdit", "MMFLoadRows", "MMFDelete", "MMFClearFilter"]),
    runJob() {
        this.$store.dispatch('quartzSchedule/runJob');
    },
    pauseJob() {
        this.$store.dispatch('quartzSchedule/pauseJob');
    },
    resumeJob() {
        this.$store.dispatch('quartzSchedule/resumeJob');
    },
    isPauseAble() {
        if(this.checkedItems.length <= 0)
            return false;
        for(var id of this.checkedItems) {
            let item = this.rows.filter(row => row['id'] == id);
            if(item[0].status == 0)
                return false
        }
        return true
    },
    isResumeAble() {
        if(this.checkedItems.length <= 0)
            return false;
        for(var id of this.checkedItems) {
            let item = this.rows.filter(row => row['id'] == id);
            if(item[0].status == 1)
                return false
        }
        return true
    }
  },
  mounted(){
      this.$store.dispatch('quartzSchedule/getAllModuleList');
  }
};
</script>
